'use strict';

var _ = require('lodash');
var ChartSponsorForecastFlightDateBoundsService = function ChartSponsorForecastFlightDateBoundsService($filter, momentService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function getMinMaxDates(data, flightLegBusinessId) {
    var minDepartureDate, maxDepartureDate;
    _.forEach(data, function (d) {
      _.forEach(d.flights, function (f) {
        if (flightLegBusinessId === undefined || flightLegBusinessId !== undefined && f.legBusinessId === flightLegBusinessId) {
          var flightDate = momentService.of(f.time.toISOString(), momentService.FIELD.DEPARTURE_TIME, 'HH:mm');
          if (_.isUndefined(minDepartureDate) || flightDate.isBefore(minDepartureDate)) {
            minDepartureDate = flightDate;
          }
          if (_.isUndefined(maxDepartureDate)) {
            maxDepartureDate = flightDate;
          } else if (flightDate.isAfter(maxDepartureDate)) {
            maxDepartureDate = flightDate;
          }
        }
      });
    });
    return {
      minDepartureDate: minDepartureDate,
      maxDepartureDate: maxDepartureDate
    };
  }
  function momentIterator(time) {
    return time.valueOf();
  }
  function getDateBounds(data) {
    var timePadding = 1;
    var timePaddingUnit = 'hour';
    var min, max;
    if (_.isEmpty(data)) {
      return {};
    }
    var minMaxDates = getMinMaxDates(data);
    min = minMaxDates.minDepartureDate.startOf('hour').subtract(timePadding, timePaddingUnit);
    max = minMaxDates.maxDepartureDate.add(1, 'hour').startOf('hour').add(timePadding, timePaddingUnit);

    //min cannot go below 00:00:00, max time cannot exceed 23:59:59
    return {
      min: _.maxBy([min, minMaxDates.minDepartureDate.startOf('day')], momentIterator),
      max: _.minBy([max, minMaxDates.minDepartureDate.endOf('day')], momentIterator)
    };
  }
  function getMinMaxTimes(data, flightLegBusinessId) {
    var min, max;
    if (_.isEmpty(data)) {
      return {};
    }
    var minMaxDates = getMinMaxDates(data, flightLegBusinessId);
    min = _.maxBy([minMaxDates.minDepartureDate, minMaxDates.minDepartureDate.startOf('day')], momentIterator);
    max = _.minBy([minMaxDates.maxDepartureDate, minMaxDates.minDepartureDate.endOf('day')], momentIterator);
    return {
      min: rmMomentFormat(min, 'TIME_USER_SETTINGS'),
      max: rmMomentFormat(max, 'TIME_USER_SETTINGS')
    };
  }
  return {
    getDateBounds: getDateBounds,
    getMinMaxTimes: getMinMaxTimes
  };
};
ChartSponsorForecastFlightDateBoundsService.$inject = ['$filter', 'MomentService'];
module.exports = ChartSponsorForecastFlightDateBoundsService;